<div>
    <div class="slider">
<!--        <slider [slidesArray]="sliderImages" [initialSlider]="initialSlider"></slider>-->
        <img src="{{imagesSrc[initialSlider]}}" class="mainImage" >

    </div>
    <!--     <div class="shop-info">{{textAbout}}</div>-->
       <products [productsCountOnPage]="12"
                 [productType]="'book'"
                 [pageName]="'main'"
                 [showPagination]="false"
                 [availability]="'in_stock,expected'"
       ></products>

       <div class="books-link" (click)="navigate('/books')" routerLinkActive="active" ariaCurrentWhenActive="page">
       <div class="books-link-text">
         Смотреть все
       </div>
       </div>
       <certificate-list></certificate-list>
   </div>
